import { Helmet } from "react-helmet";
import fbIcon from "../images/Last-Section/FB@4x.png";
import instaIcon from "../images/Last-Section/Insta@4x.png";
import linkedinIcon from "../images/Last-Section/Linkedin@4x.png";
import xIcon from "../images/Last-Section/x@4x.png";
import dumoshLogo from "../images/Last-Section/Dumosh Logo@4x.png";
import GrowthImage from "../images/Last-Section/growth2@4x.png"; // adjust the path as needed

export default function CallToAction({ openModal }: any) {
  return (
    <div className="bg-white text-gray-800 font-poppins">
      <Helmet>
        <title>Dumosh - Transform Your Healthcare Practice</title>
      </Helmet>

      {/* Hero Section */}
      <div className="max-w-6xl mx-auto md:px-6 px-2 pb-0 text-center">
        <div className="flex flex-col lg:flex-row items-center justify-between">

          {/* Illustration */}
          <div className="">
            <img
              src={GrowthImage}
              alt="Person climbing toward growth"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>

        {/* Subtext */}
        <h2 className="text-[#58595B] md:text-[24px] text-[18px] lg:text-[32px] font-medium mb-6">
          Ready to Transform Your Practice?
        </h2>

        {/* CTA Button */}
        <button
          onClick={openModal}
          className="bg-[#E91212] text-white px-6 py-2 md:px-8 md:py-3 rounded-xl font-bold text-sm md:text-xl hover:bg-[#e34242] transition-transform duration-300 transform hover:scale-105">
          Let’s Get Started!
        </button>

        {/* Content Section */}
        <section className="mt-10 px-4 text-center">
          <div className="max-w-4xl mx-auto">
            {/* Heading */}
            <h2 className="text-[#58595B] text-[24px] lg:text-[32px] font-bold mb-4 leading-snug">
              Partner with Dumosh Today and Experience
              <br className="hidden sm:block" />
              Assured Business Growth
            </h2>

            {/* Paragraph */}
            <p className="text-black text-[16px] lg:text-[18px] mb-12 leading-relaxed tracking-wide">
              The healthcare landscape is evolving, and the practices that thrive are the ones that embrace
              <br className="hidden sm:block" />
              innovation and strategic marketing. At Dumosh, we’re here to help you stay ahead of the curve
              <br className="hidden sm:block" />
              and achieve your growth goals.
            </p>

            {/* Subheading */}
            <h2 className="text-[#58595B] text-[24px] lg:text-[32px] font-bold mb-2">
              Why Wait?
            </h2>

            {/* Bottom Paragraph */}
            <p className="text-black text-[16px] lg:text-[18px] leading-relaxed tracking-wide">
              Contact us today to schedule a <span className="font-bold">free consultation</span> and discover how our
              <br className="hidden sm:block" />
              tele-calling and digital marketing services can transform your practice.
            </p>
          </div>
        </section>

      </div>

      {/* Footer */}
      <footer className="bg-blue-600 text-white mt-10 py-12">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center md:items-start space-y-10 md:space-y-0 text-center md:text-left">
          {/* Logo */}
          <div className="w-full md:w-auto">
            <p className="text-white text-2xl lg:text-4xl font-anton">
              DUMOSH<span className="text-[#FF3E3E]">.</span>
            </p>
          </div>

          {/* Contact Info */}
          <div className="w-full md:w-auto">
            <p className="uppercase text-sm font-medium">Contact</p>
            <p className="text-lg font-semibold mt-2">+91 99235 09923</p>
          </div>

          {/* Email */}
          <div className="w-full md:w-auto">
            <p className="uppercase text-sm font-medium">Email</p>
            <p className="text-lg font-semibold mt-2">shadab@dumosh.in</p>
          </div>

          {/* Social Icons */}
          <div className="w-full md:w-auto">
            <p className="uppercase text-sm font-medium mb-3">Follow Us</p>
            <div className="flex justify-center md:justify-start space-x-5">
              <a href="https://www.facebook.com/dumoshindia/" target="_blank" rel="noreferrer">
                <img src={fbIcon} alt="Facebook" className="w-8 h-8" />
              </a>
              <a href="#" target="_blank" rel="noreferrer">
                <img src={xIcon} alt="Twitter" className="w-8 h-8" />
              </a>
              <a href="https://www.instagram.com/the_dumosh/" target="_blank" rel="noreferrer">
                <img src={instaIcon} alt="Instagram" className="w-8 h-8" />
              </a>
              <a href="https://www.linkedin.com/company/dumosh/" target="_blank" rel="noreferrer">
                <img src={linkedinIcon} alt="LinkedIn" className="w-8 h-8" />
              </a>
            </div>
          </div>
        </div>
      </footer>

    </div>
  );
}
